import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=1d56456c&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=1d56456c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d56456c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogPostsSubscribe: require('/home/circleci/repo/components/blog/BlogPostsSubscribe.vue').default,MenuListTopFranchise: require('/home/circleci/repo/components/menu/MenuListTopFranchise.vue').default,Footer: require('/home/circleci/repo/components/Footer.vue').default})
